import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  // Dark-first: só usa light se o usuário escolheu explicitamente
  const isDark = ref(localStorage.getItem('betia-theme') !== 'light');

  function apply() {
    if (isDark.value) {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.add('light');
    }
    localStorage.setItem('betia-theme', isDark.value ? 'dark' : 'light');
  }

  function toggle() {
    isDark.value = !isDark.value;
  }

  watch(isDark, apply, { immediate: true });

  return { isDark, toggle };
});
